<p>
    {{ "redirecting" | translate }}
</p>